import { LabeledAvatar } from '@change/ds-core-ui/next';

import type { ShareFeedItem as ShareFeedItemType } from 'src/app/pages/psf/share/pageContext';

import { useShareFeedItem } from './hooks/useShareFeedItem';

type Props = Readonly<{
	item: ShareFeedItemType;
	className?: string;
}>;

export function ShareFeedItem({ item, className }: Props) {
	const {
		data: { altText, metaText },
	} = useShareFeedItem(item);

	return (
		<LabeledAvatar
			alt={altText}
			container="inline"
			metatext={metaText}
			name={item.userDisplayName}
			size="x-small"
			src={item.userPhoto ?? undefined}
			className={className}
		/>
	);
}
